<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template v-slot:no-data>
        Sem dados
      </template>
      <template #[`item.nome`]="{ item }">
        <router-link
          :to="{ name: 'cargo', params: { id: item.id } }"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
              `"
              >
                {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column ms-3">
              {{ item.nome }}
            </div>
          </div>
        </router-link>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo === true ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo === true ? 'success' : 'secondary'}`"
        >
          {{ item.ativo === true ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="acessoDisable"
            >
              <v-list-item-title
                role="button"
                @click="deleteItem(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span>{{ item.ativo ? 'Inativar' : 'Ativar' }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogDelete"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          {{ `${!inativar.ativar ? 'Inativar' : 'Ativar'}` }}
        </v-card-title>
        <v-card-text>
          {{ `Tem certeza que deseja ${!inativar.ativar ? 'inativar' : 'ativar'}? ` }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDelete"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarInativacao"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiCheckBold, mdiDotsVertical, mdiDelete, mdiCloseThick } from '@mdi/js'
import CargoService from '@/services/modules/CargoService'

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    acessoDisable: {
      type: Boolean,
      default: () => true,
    },
  },

  data: () => ({
    dialogDelete: false,
    dialogInativar: false,
    loading: false,
    icons: {
      mdiDelete,
      mdiDotsVertical,
      mdiCheckBold,
      mdiCloseThick,
    },

    inativar: {
      ativar: true,
    },
    idCargo: 0,

    headers: [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ],
  }),

  methods: {
    confirmarInativacao() {
      this.loading = true

      CargoService
        .ativarOuInativar(this.idCargo, this.inativar)
        .then(() => {
          this.closeDelete()
          this.$emit('confirmar-inativacao')
          this.loading = false
        })
        .catch(() => {
          this.closeDelete()
          this.loading = false
        })
    },

    deleteItem(item) {
      this.idCargo = item.id
      this.dialogDelete = true
      if (item.ativo) { this.inativar.ativar = false } else { this.inativar.ativar = true }
    },

    closeDelete() {
      this.dialogDelete = false
    },
  },
}
</script>
